import React from 'react';
import { withTranslation } from 'react-i18next';
import './ProductCard.sass';

class ProductCard extends React.Component {
  #title;
  #content;
  #children;

  constructor(props) {
    super(props);
    this.#title = props.title;
    this.#content = props.content;
    this.#children = props.children || null;
  }

  render() {
    return (
      <div className="ProductCard section__block section__block--border">
        {this.#children && (
          <div className="ProductCard__icon">
            {this.#children}
          </div>
        )}
        <div className="ProductCard__title">
          {this.#title}
        </div>
        <div className="ProductCard__content">
          {this.#content}
        </div>
      </div>
    );
  }
}

export default withTranslation()(ProductCard);
